import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {OrdersActions} from '../store';
import {OrdersSelectors} from '../store/selectors';
import {isLoaded} from '../store/selectors/orders.selectors';

@Injectable()
export class OrdersLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadOrdersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadOrdersDone(): Observable<boolean> {
    return this.store.pipe(
      select(OrdersSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store.dispatch(OrdersActions.ReadOrders({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
